import { GetProductOffersResponse } from '@iwoca/lapi-client/edge';
import { TUKSupportedDocument } from './NewDocUploads.types';

export const getRequiredDataRequirements = (
    productOffers: GetProductOffersResponse['data'],
    supportedDocuments: TUKSupportedDocument[]
) => {
    const suggestedProduct = productOffers!.products.find(
        (product) => product.is_suggested
    );

    if (!suggestedProduct) return [];

    const nonOptionalDataRequirements =
        suggestedProduct.data_requirements.filter(
            (requirement) =>
                supportedDocuments.includes(
                    requirement.type as TUKSupportedDocument
                ) && !requirement.is_optional
        );

    return nonOptionalDataRequirements;
};

export const getRemainingDataRequirements = (
    productOffers: GetProductOffersResponse['data'],
    supportedDocuments: TUKSupportedDocument[]
) => {
    const requiredDocs = getRequiredDataRequirements(
        productOffers,
        supportedDocuments
    );
    return requiredDocs.filter((req) => req.status === 'required');
};
